import { Link } from 'react-router';
import { cn } from '@/lib/cn';

export function Logo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      aria-label="VYBE"
      className={cn('group inline-flex items-center gap-2.5', className)}
    >
      <svg viewBox="0 0 64 64" className="size-8" aria-hidden>
        <rect width="64" height="64" rx="18" className="fill-ink-700" />
        <path
          d="M18 20l14 26 14-26"
          fill="none"
          stroke="var(--color-volt-400)"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-lg font-extrabold tracking-[0.18em] text-fg">VYBE</span>
    </Link>
  );
}
